import React from "react";
import { StyleSheet, View, Text, Linking } from "react-native";
import i18n from "@microdoing/shared/i18n";
import Colors from "@microdoing/shared/constants/Colors";
// import CheckBox from "react-native-check-box";
import CheckBox from "@react-native-community/checkbox";

import { widthPercentageToDP } from "react-native-responsive-screen";

const styles = StyleSheet.create({
  main: {
    width: widthPercentageToDP("85%"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    marginBottom: 25,
  },
  signupPolicy: {
    marginLeft: 10,
    marginRight: 15,
    textAlign: "center",
    fontSize: 11,
    color: "#A8A9B7",
  },
});

const ClientPolicyCheck = ({
  signupPolicy = `En cochant cette case, j’atteste être salarié de l’entreprise   CITY ONE ACCUEIL PASSAGER , 23 rue lafayette 31000 toulouse, SIRET - 483 897 369 00011 actuellement en chômage partiel atteste accepter de suivre la formation suivante durant ma période de chômage partiel :
Atteindre l’excellence opérationnelle même en situation de crise via l’application Microdoing. 

Je suis informé(e) que cette formation est financée par le Fonds National pour l’Emploi (FNE) – Formation-COVID 19 de l’Etat. Je suis informé(e) que mon inscription s’est réalisée à distance par voie électronique.`,
  onCheckPolicy,
  isClientPolicyChecked,
}) => {
  return (
    <View style={styles.main}>
      <CheckBox onValueChange={onCheckPolicy} value={isClientPolicyChecked} />
      <Text onPress={onCheckPolicy} style={styles.signupPolicy}>
        {signupPolicy}
      </Text>
    </View>
  );
};

export default ClientPolicyCheck;
